import { type RequestTypeEnum } from '@webapp/core/entities/internal/enums/RequestTypeEnum'
import {
  legalEntityKeys,
  legalEntityRepository,
} from '@webapp/platform/legal-entities/data-access/repositories/LegalEntityRepository'

/**
 * Shared react-query configs for reading LegalEntity data.
 *
 * `list` returns every entity (active + inactive) under a single query key, so
 * the list view and the duplicate-name check share one cached request.
 *
 * `requestable` returns the entities the current user can raise the given
 * request type in, keyed by that type so each request surface caches its own.
 */
export const legalEntityQueryConfig = {
  list: () => ({
    queryKey: legalEntityKeys.list,
    queryFn: () => legalEntityRepository.list(),
  }),
  requestable: (requestType: RequestTypeEnum) => ({
    queryKey: legalEntityKeys.requestable(requestType),
    queryFn: () =>
      legalEntityRepository.listRequestableForCurrentUser(requestType),
  }),
}
